// extracted by mini-css-extract-plugin
module.exports = {"logo":"_0fce717cdb--logo--3YYJ7"};